import { MediaLibraryBrowser } from '@/features/MediaLibrary/MediaLibraryBrowser';

/** Открывает административную медиатеку */
export const MediaLibraryPage = () => <MediaLibraryBrowser />;
